import React from "react";
import styled from "styled-components";

export const H5Bold = styled((props) => <h5 {...props} />).attrs((props) => ({
  automationid:
    props.automationid ||
    `mmr2_h5_${props?.automationidattr?.replace(/ /g, "")}_1"`,
}))`
  font-family: "Roboto" !important;
  font-weight: 700 !important;
  color: #333333;
  font-size: ${(props) => (props.font_size ? props.font_size : "1.25em")};
  line-height:  ${(props) => (props.line_height ? props.line_height : "1.875em")};
  text-align: ${(props) => (props.textalign ? props.textalign : "left")};
  margin:${(props) => (props.margin_size || "1.25em")};

  @media only screen and (min-width: 320px) and (max-width: 450px) {
    font-weight: 500;
    font-size: 20px;
    margin: ${(props) => (props.marginm ? props.marginm : "0")};
    text-align: ${(props) => (props.textalignm ? props.textalignm : "left")};
  }
`;
